export type CacheVerificationType = 'bank' | 'tin' | 'iban' | 'gst' | 'email_domain' | 'eu_vat';

export type CacheVerificationStatus = 'idle' | 'loading' | 'pending' | 'verified' | 'failed' | 'timeout';

export interface VerificationCacheEntry {
  readonly key: string;
  readonly type: CacheVerificationType;
  readonly panelIndex: number;
  readonly status: CacheVerificationStatus;
  readonly resultId: string | null;
  readonly providerResponse: unknown;
  readonly runOn: string | null;
  readonly pollCount: number;
  readonly cooldownUntil: number | null;
  readonly error: unknown;
  readonly isExpired: boolean;
}

export type BackendVerificationStatus = 'PENDING' | 'VERIFIED' | 'FAILED';

export const VERIFICATION_POLL_INTERVAL_MS = 3_000;
export const VERIFICATION_MAX_POLLS = 20;
export const VERIFICATION_REVERIFY_COOLDOWN_MS = 30_000;
